<template>
  <v-card
    no-gutter
    style="
      width: 100% !important;
      height: 100% !important;
      overflow: hidden;
      overflow-y: scroll;
    "
    class="align-center justify-center text-center hide-scrollbar"
  >
    <v-card-title class="headline mb-2"
      >{{ $t("tagdata.name") + " - " + module.tag.name }}
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      class="weathertable hide-scrollbar"
      dense
      :search="search"
      :items-per-page="15"
    >
      <template v-slot:createdAt="{ item }">
        {{ humanDate(item.createdAt) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "RawTable",

  props: ["module", "timerTick"],

  methods: {
    ...mapActions("tagData", { getData: "getTagDataAsync" }),

    async loadData() {
      let td = await this.getData({
        metrics: {
          tag: this.module.tag.deveui,
          limit: 100,
        },
      });

      this.items = td;
    },

    async getNewData() {
      let td = await this.getData({
        metrics: {
          tag: this.module.tag.deveui,
          from: this.fromDate.toISOString(),
        },
      });

      for (let t in td) {
        if (this.items.length >= 100) this.items.shift();
        this.items.push(td[t]);
      }

      this.fromDate = new Date();
    },
  },

  data() {
    return {
      headers: [
        { text: this.$t("tagdata.fields.key"), value: "key" },
        { text: this.$t("tagdata.fields.value"), value: "value" },
        { text: this.$t("tagdata.fields.createdAt"), value: "createdAt" },
      ],
      items: [],
      loading: true,
      search: null,
      fromDate: new Date(),
    };
  },

  async mounted() {
    this.loadData();
    this.loading = false;
  },

  watch: {
    timerTick(v) {
      if (v % 8 == 0) {
        this.getNewData();
      }
    },
  },
};
</script>

<style scoped>
.weathertable {
  height: 100%;
}
</style>
